import { render, staticRenderFns } from "./TownshipChoose.vue?vue&type=template&id=f700c934&scoped=true&"
import script from "./TownshipChoose.vue?vue&type=script&lang=js&"
export * from "./TownshipChoose.vue?vue&type=script&lang=js&"
import style0 from "./TownshipChoose.vue?vue&type=style&index=0&id=f700c934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f700c934",
  null
  
)

export default component.exports